import React from "react"
import styled from "styled-components"
import { Paragraph, HeadingTwo, RoundButton } from "buoy-core"
import { colors, responsive } from "buoy-theme"
import { pushRoute } from "../../common/route"
import desktopHeroImg from "../../../static/images/dashboard/hero-d.svg"
import mobileHeroImg from "../../../static/images/dashboard/hero-m.svg"
import BuoyAssistantLogo from "../../common/components/BuoyAssistantLogo"
import Tooltip from "../../common/components/Tooltip"

const config = {
  heading: "Worried about a new symptom?",
  body:
    "Buoy Assistant can help you figure out what's going on and what to do about it.",
  button: {
    text: "Check My Symptoms",
    path: "/symptom-checker/",
  },
  tooltip:
    "Chat with Buoy's A.I. health assistant to get the answers you need. Buoy asks questions to examine and analyze your symptoms. You’ll see a personalized plan for what to do next so you can get on your way to well. FREE & available 24/7.",
}

const TooltipContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
`

const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  ${responsive(
    "padding",
    "40px 190px 40px 40px",
    "40px 190px 40px 40px",
    "40px 190px 40px 40px",
    "24px 16px 180px",
    "24px 16px 220px"
  )};
  ${responsive("margin-top", "64px", "64px", "24px", "24px", "16px")};
  position: relative;
  flex-direction: column;
  border-radius: 4px;
  background-color: ${colors.primary};

  ${responsive(
    "background-image",
    `url(${desktopHeroImg})`,
    `url(${desktopHeroImg})`,
    `url(${desktopHeroImg})`,
    `url(${mobileHeroImg})`,
    `url(${mobileHeroImg})`
  )};

  background-size: cover;
  background-position: bottom right;
  background-repeat: no-repeat;
`

const Heading = styled(HeadingTwo)`
  margin-bottom: 12px;
`

const SymptomCheckerButton = styled(RoundButton)`
  width: 253px;
  ${responsive("margin-top", "24px", "24px", "24px", "24px", "20px")};
`

const HeroParagraph = styled(Paragraph)`
  max-width: 397px;
`

const HeroCard = () => (
  <CardWrapper>
    <BuoyAssistantLogo />
    <Heading color="white" alignLeft>
      {config.heading}
    </Heading>
    <HeroParagraph color="white">{config.body}</HeroParagraph>
    <SymptomCheckerButton
      color="neutralLightest"
      textColor="primary"
      onClick={() => pushRoute(config.button.path, false)}
    >
      {config.button.text}
    </SymptomCheckerButton>
    <TooltipContainer>
      <Tooltip message={config.tooltip} />
    </TooltipContainer>
  </CardWrapper>
)

export { HeroCard as default }



// WEBPACK FOOTER //
// ./assets/dashboard/components/HeroCard.js